import React from 'react';
import './style.scss';

export const LoadingAnimation = () => <div className="app-loading-animation"/>